import { RemoveBasketItemType } from '../../../types/basket';
import { Track } from '../../../weborder/analytics';
import * as BasketControl from '../../../weborder/BasketControl';

type CheckoutButtonStateType = {
  buttonLabel: string;
  isCheckoutEnabled: boolean;
};
type RemoveItemPayloadType = {
  menuId: number;
  index: number;
  indexName?: string;
};

const getAriaLabel = (
  name: string,
  description: string,
  from: boolean,
  currencySymbol: string,
  translate: any,
): string =>
  `${name}, ${description} ${from && translate('From')} ${currencySymbol}`;

const getButtonState = (
  acceptPreOrders: boolean,
  isDeliveryOrder: boolean,
  isOutsideDeliveryZone: boolean,
  isOpen: boolean,
  translate: any,
): CheckoutButtonStateType => {
  if (isDeliveryOrder && isOutsideDeliveryZone) {
    return {
      buttonLabel: translate('Cannot_deliver_checkout'),
      isCheckoutEnabled: false,
    };
  }

  if (isOpen) {
    return {
      buttonLabel: translate('Checkout'),
      isCheckoutEnabled: true,
    };
  }

  if (acceptPreOrders) {
    return {
      buttonLabel: translate('Preorder'),
      isCheckoutEnabled: true,
    };
  }

  return {
    buttonLabel: translate('Closed'),
    isCheckoutEnabled: false,
  };
};

const getCategoryTranslationKey = (category: number): string => {
  switch (category) {
    case 0:
      return 'Restaurant_lowercase';
    case 1:
      return 'Cafe_lowercase';
    case 2:
      return 'Store_lowercase';
    default:
      return 'Restaurant_lowercase';
  }
};

const handleScrollToSection = (targetId: string): void => {
  const targetSection = document.getElementById(targetId);
  targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const handleAddItem = (
  actionAddItem: (payload: BasketControl.Item) => void,
  data: BasketControl.Item,
  menuId: number,
  vrId: number,
): void => {
  Track('Restaurants', 'Add Item To Basket Via Basket', {
    event_label: data.Item.Name,
    itemType: data.Options.length === 0 ? 'simple' : 'complex',
    menuId: menuId,
    name: data.Item.Name,
    virtualRestaurantId: vrId,
  });

  actionAddItem({
    Item: data.Item,
    Options: data.Options,
  });
};

const handleRemoveItem = (
  actionRemoveItem: (payload: RemoveItemPayloadType) => void,
  data: RemoveBasketItemType,
  vrId: number,
): void => {
  Track('Restaurants', 'Remove Item From Basket Via Basket', {
    event_label: data.item.Name,
    menuId: data.menuId,
    virtualRestaurantId: vrId,
  });

  actionRemoveItem({
    index: data.index,
    indexName: data.item.Name,
    menuId: data.menuId,
  });
};

export const menuUtils = {
  getAriaLabel,
  getButtonState,
  getCategoryTranslationKey,
  handleAddItem,
  handleRemoveItem,
  handleScrollToSection,
};
